import { IAddressModel } from "../models/Address.Model";
import { isTokenExpired } from "../helpers/TokenHelper";
import { findedLocation } from "../helpers/Helper";
import createHttpInstance from "./http-common";

class UserAddressServices {
    private serviceName = '/UserAddress';

    async create(data: IAddressModel) {
        isTokenExpired();
        const httpCommon = await createHttpInstance();
        return httpCommon.post(`${this.serviceName}/create`, data).catch((err: Error) => {
            throw err?.message;
        })
    }

    async edit(data: any) {
        isTokenExpired();
        const httpCommon = await createHttpInstance();
        return httpCommon.post(`${this.serviceName}/edit`, data).catch((err: Error) => {
            throw err?.message;
        })
    }

    async remove(id: number) {
        isTokenExpired();
        const httpCommon = await createHttpInstance();
        return httpCommon.post(`${this.serviceName}/remove/${id}`).catch((err: Error) => {
            throw err?.message;
        })
    }

    async GetPersonAddress(personId: any) {
        isTokenExpired();
        const httpCommon = await createHttpInstance();
        return httpCommon.post(`${this.serviceName}/GetPersonAddress?personId=${personId}`, {
            headers: {
                "LanguageCode": findedLocation().LanguageCode,
                "CountryCode": findedLocation().CountryCode
            }
        }).catch((err: Error) => {
            throw err?.message;
        })
    }
}

export default new UserAddressServices();